// extracted by mini-css-extract-plugin
export default {"wrapper":"trait-module--wrapper--138ca","disadvantage":"trait-module--disadvantage--7c387"};